import { msgTypes } from "constants/msgTypes";
import { Validation } from "constants/Validation";
import * as Yup from "yup";

export const AnnouncementSchema = Yup.object({
    announcementId: Yup.string(),
    title: Yup.string().required(Validation.required.message.replaceAll("^","Title"))
                    .matches(Validation.plaintext.regex , Validation.plaintext.message),
    message: Yup.string().required(Validation.required.message.replaceAll("^","Message"))
            .matches(Validation.plaintext.regex , Validation.plaintext.message),
    attachment: Yup.string().required(Validation.required.message.replaceAll("^","Attachment")),
    attachmentFile: Yup.mixed().nullable()
    .test(
        "FILE_FORMAT",
        msgTypes.IMAGE_UNSUPPORTED_FORMAT,
        (value) => !value || (value && [msgTypes.IMAGE_FORMAT.JPEG,msgTypes.IMAGE_FORMAT.PDF,
            msgTypes.IMAGE_FORMAT.JPG, msgTypes.IMAGE_FORMAT.PNG, msgTypes.IMAGE_FORMAT.WEBP, msgTypes.IMAGE_FORMAT.WORD
        ].includes(value?.type))
    )
    .test(
        "FILE_SIZE",
        msgTypes.FILE_SIZE_MESSAGE_3MB,
        (value) =>!value || (value && value.size <=msgTypes.FILE_SIZE_3MB)
    )
   })